<template>
  <div v-if="history.length">
    <div class="a-container-form">
      <div class="a-label a-label--w-280"></div>
      <div>
        <button v-if="isCollapsed"
                class="gui-btn gui-btn--link"
                @click.prevent="isCollapsed = false">
          Показать историю изменений
        </button>
        <button v-else
                class="gui-btn gui-btn--link"
                @click.prevent="isCollapsed = true">
          Скрыть историю изменений
        </button>
      </div>
    </div>
    <div class="a-container-form" v-if="!isCollapsed">
     <div class="admin__a-tab-content admin__a-tab-content--show">
       <div class="a-ui-tab u-margin-b-24">
         <div class="a-ui-tab__block">
           <div class="a-ui-tab__content-block">
             <section v-maximizable>
              <div class="table-tab">
               <div class="table-tab__container" style="overflow-x: auto">
                 <table class="table-tab__block table " style="width: 100%">
                   <thead class="table-tab__thead table-tab__border-bottom">
                     <tr class="">
                       <th>№</th>
                       <th>ФИО</th>
                       <th>Дата изменения</th>
                       <th>Описание</th>
                     </tr>
                   </thead>

                   <tbody>
                    <tr v-for="(item, idx) of history">
                      <th class="table-tab__th">
                        {{idx + 1}}
                      </th>
                      <th>
                        {{item.owner}}
                      </th>
                      <th><date-time tag="span" :value="item.time"></date-time></th>
                      <th v-html="escape(item.description)"></th>
                    </tr>
                   </tbody>
                 </table>
               </div>
             </div>
             </section>
           </div>
         </div>
       </div>
     </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    props: {
      lot: Object
    },

    data: () => ({
      isCollapsed: true
    }),

    computed: {
      history() {
        return _.orderBy(this.lot.lotHistory, 'time', 'asc');
      }
    }
  }
</script>

<style scoped>

</style>
